<template>
    <div>
        <div class="title">SMS Campaign Creation</div>
        <v-stepper v-model="e1">
            <v-stepper-header>
                <v-stepper-step
                    :complete="e1 > 1"
                    step="1"
                >
                    Info And Data Creation ( Step 1 )
                </v-stepper-step>
                <v-divider />
                <v-stepper-step
                    :complete="e1 > 2"
                    step="2"
                >
                    SMS Message Creation ( Step 2 )
                </v-stepper-step>
                <v-divider />
                <v-stepper-step step="3">
                    Submit SMS Campaign ( Step 3 )
                </v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <sms-campaign-create-first-step
                        @next-step="nextStep"
                        @prev-step="prevStep"
                        @reset="reset"
                        @cancel="cancel"
                    />
                </v-stepper-content>

                <v-stepper-content step="2">
                    <sms-campaign-create-second-step
                        @set-alert="setAlert"
                        @next-step="nextStep"
                        @prev-step="prevStep"
                        @reset="reset"
                        @cancel="cancel"
                    />
                </v-stepper-content>

                <v-stepper-content step="3">
                    <sms-campaign-create-third-step
                        @set-alert="setAlert"
                        @prev-step="prevStep"
                        @reset="reset"
                        @cancel="cancel"
                    />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </div>
</template>

<script>
    import Alert from '@/components/Alert'
    import smsCampaignCreateFirstStep from '@/components/SMSCampaignCreateFirstStep.vue'
    import smsCampaignCreateSecondStep from '@/components/SMSCampaignCreateSecondStep.vue'
    import smsCampaignCreateThirdStep from '@/components/SMSCampaignCreateThirdStep.vue'
    import EventBus from '@/event-bus'
    export default {
        components: { Alert, smsCampaignCreateFirstStep, smsCampaignCreateSecondStep, smsCampaignCreateThirdStep },
        data() {
            return {
                showAlert: false,
                message: '',
                type: null,
                e1: 1
            }
        },
        watch: {
            showAlert: {
                handler(newval, oldval) {
                    if (newval !== oldval) {
                        setTimeout(() => { this.showAlert = false }, 3000)
                    }
                }
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
            },
            nextStep() {
                this.e1++
            },
            prevStep() {
                this.e1--
            },
            cancel() {
                this.$router.push({ path: '/sms' })
            },
            reset() {
                this.$store.dispatch('setCurrentSMSCampaign', {})
                this.e1 = 1
                EventBus.$emit('reset-new-campaign-form')
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
